import { api } from '@/lib/api';
import type {
  TrainingPackage,
  TrainingPackageSchedule,
  TrainingPackagePreview,
  CreateTrainingPackageRequest,
  VerifyPackagePaymentRequest,
} from './types';

/** Vendor read-only grouping of training packages (child sessions under each package). */
export async function fetch_vendor_training_packages(): Promise<TrainingPackage[]> {
  const res = await api.get<TrainingPackage[]>('/vendor/training-packages');
  return res.data;
}

/** Vendor one-time acceptance of a whole package (confirms every awaiting session at once). */
export async function accept_training_package(id: string): Promise<TrainingPackage> {
  const res = await api.post<TrainingPackage>(`/vendor/training-packages/${id}/accept`);
  return res.data;
}

/** Vendor one-time rejection of a whole package (declines every awaiting session at once). */
export async function reject_training_package(id: string, reason?: string): Promise<TrainingPackage> {
  const res = await api.post<TrainingPackage>(`/vendor/training-packages/${id}/reject`, { reason });
  return res.data;
}

// ---- User (pet-owner) training-package endpoints ----

/** Dry-run the schedule → concrete generated sessions + total, before creating anything. */
export async function preview_training_package(input: TrainingPackageSchedule): Promise<TrainingPackagePreview> {
  const res = await api.post<TrainingPackagePreview>('/user/training-packages/preview', input);
  return res.data;
}

/** Create the package (bulk-generates PENDING_PAYMENT child sessions + one package payment). */
export async function create_training_package(input: CreateTrainingPackageRequest): Promise<TrainingPackage> {
  const res = await api.post<TrainingPackage>('/user/training-packages', input);
  return res.data;
}

/** Dummy-gateway confirm (no razorpay checkout). Activates the package. */
export async function pay_training_package(id: string): Promise<TrainingPackage> {
  const res = await api.post<TrainingPackage>(`/user/training-packages/${id}/pay`);
  return res.data;
}

/** Verify a razorpay package payment (post-checkout). */
export async function verify_training_package_payment(id: string, input: VerifyPackagePaymentRequest): Promise<TrainingPackage> {
  const res = await api.post<TrainingPackage>(`/user/training-packages/${id}/pay/verify`, input);
  return res.data;
}

export async function fetch_my_training_packages(): Promise<TrainingPackage[]> {
  const res = await api.get<TrainingPackage[]>('/user/training-packages');
  return res.data;
}

export async function cancel_training_package(id: string, reason?: string): Promise<TrainingPackage> {
  const res = await api.post<TrainingPackage>(`/user/training-packages/${id}/cancel`, { reason });
  return res.data;
}
